var render = function () {
  var _vm$inquiry, _vm$inquiry$product, _vm$inquiry2, _vm$inquiry2$product;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1024"
    }
  }, [_c('console-title', [_vm.inquiry._id ? _c('span', [_vm._v("상품문의 상세")]) : _c('span', [_vm._v("상품문의 등록")])]), _c('console-body', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_vm._v(" 작성자 : " + _vm._s(_vm.inquiry.writer.name) + " (" + _vm._s(_vm.inquiry.writer.username) + ") ")]), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_vm._v(" 문의일자 : " + _vm._s(_vm.$dayjs(_vm.inquiry.createdAt).format('YYYY-MM-DD HH:mm:ss')) + " ")])], 1)], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("문의상품")]), _c('v-responsive', {
    staticClass: "px-4 grey lighten-4"
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": (_vm$inquiry = _vm.inquiry) === null || _vm$inquiry === void 0 ? void 0 : (_vm$inquiry$product = _vm$inquiry.product) === null || _vm$inquiry$product === void 0 ? void 0 : _vm$inquiry$product.thumb,
      "width": "96",
      "height": "96",
      "contain": ""
    }
  })], 1), _c('v-flex', {
    staticClass: "text-start"
  }, [_c('div', {
    staticClass: "mx-2 text-truncate"
  }, [_c('b', [_vm._v(_vm._s(((_vm$inquiry2 = _vm.inquiry) === null || _vm$inquiry2 === void 0 ? void 0 : (_vm$inquiry2$product = _vm$inquiry2.product) === null || _vm$inquiry2$product === void 0 ? void 0 : _vm$inquiry2$product.name) || "삭제된 상품"))])])])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("문의내용")]), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: _vm.inquiry.content,
      callback: function callback($$v) {
        _vm.$set(_vm.inquiry, "content", $$v);
      },
      expression: "inquiry.content"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("답변")]), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.inquiry.answer,
      callback: function callback($$v) {
        _vm.$set(_vm.inquiry, "answer", $$v);
      },
      expression: "inquiry.answer"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "my-4"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }